import type { CreateProjectBody } from '@si/types';
import { postForm } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useState } from 'react';

export function useCreateProject() {
  const queryClient = useQueryClient();
  const [newProjectId, setNewProjectId] = useState<number | null>(null);

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ formData }: { formData: FormData }) =>
      postForm<{ projectId: number }>({
        url: `/projects`,
        body: formData,
      }),
    onSuccess: ({ projectId }) => {
      setNewProjectId(projectId);
      queryClient.invalidateQueries({
        predicate: ({ queryKey }) => Array.isArray(queryKey) && queryKey[0] === 'projects',
      });
    },
  });

  const createProject = useCallback(
    ({
      projectData,
      contextImg,
      orientationImg,
    }: {
      projectData: CreateProjectBody;
      contextImg: File | null;
      orientationImg: File | null;
    }) => {
      const formData = new FormData();
      formData.append('projectData', JSON.stringify(projectData));
      if (contextImg) {
        formData.append('contextImg', contextImg);
      }
      if (orientationImg) {
        formData.append('orientationImg', orientationImg);
      }

      mutate({ formData });
    },
    [mutate]
  );

  return {
    createProject,
    error,
    isPending,
    isSuccess,
    reset,
    newProjectId,
  };
}
